import Axios from "axios";

import { BaseResponse } from "../helpers";

import { aws4Interceptor } from "aws4-axios";

const axios = Axios.create({
  baseURL: process.env.SDK_PHP_API,
  data: {},
  headers: { "Content-Type": "application/json" },
});


const interceptor = aws4Interceptor(
  {

    region: process.env.SDK_APP_REGION,

    service: "execute-api",

  },
  {
    accessKeyId: process.env.SDK_APP_ACCESSKEY!,

    secretAccessKey: process.env.SDK_APP_SECRETKEY!,
  }
);



axios.interceptors.request.use(
  function (config) {
    config.headers!["x-api-key"] = process.env.SDK_APP_X_API_KEY!;
    console.log('process.env.VUE_APP_X_API_KEY!',process.env.SDK_APP_X_API_KEY!)
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (response) {
    
    if(response.data.code != 0){
     return Promise.reject(response)
    }
    return response;
  },
  function (error) {
    // console.log(error.response.status);
    // // instance.close()

    // if (error.response.status == 422) {
    //   message.error(error.response.data.error);
    // }
    // if (error.response.status == 403) {
    //   message.error(error.response.data.error);
    // }
    return Promise.reject(error);
  }
);
axios.interceptors.request.use(interceptor)
interface RequsetOptions {
  data: Record<string, any>;
  otherOptions: Record<string, any>;
}
/**
 * api
 *
 * @export
 * @class Api
 * 静态方法 get post put delete
 *
 * @url 请求路径
 * @pkId 主键
 * @actions 基于url上扩展的方法
 *
 */
/** 
 * actions 事例
{
    approval: {
        method: 'put', 
        url: 'approval/{id}'
    }
}
*/
export default class Api {
  url: string;
  pkId: string;
  actions: Record<string, any> = {};
  constructor(url: string, pkId?: string, actions = {}) {
    if (!/\/$/.test(url)) {
      url = url + "/";
    }
    this.url = url;
    
    this.pkId = pkId ?? '';
    // 基于baseUrl上扩展的请求
    Object.keys(actions).forEach((key) => {
      this[key] = (data: any, otherOptions: any) => {
        const url = formatUrl(this.url + actions[key].url, data);
        return send(url, data, otherOptions, actions[key].method);
      };
    });
  }

  get<T>(data: any, otherOptions: any) {
    let url = `${this.url}{${this.pkId}}`;
    url = formatUrl(url, data);
    return send<T>(url, data, otherOptions);
  }
  query<T>({ data = {}, otherOptions = {} }: Partial<RequsetOptions>) {
    return send<T>(this.url, data, otherOptions);
  }
  create<T>({ data = {}, otherOptions = {} }: Partial<RequsetOptions>) {
    return send<T>(this.url, data, otherOptions, "post");
  }
  update(data: any, otherOptions: any) {
    let url = `${this.url}{${this.pkId}}`;
    url = formatUrl(url, data);
    return send(url, data, otherOptions, "put");
  }
  delete(data: any, otherOptions: any) {
    let url = `${this.url}{${this.pkId}}`;
    url = formatUrl(url, data);
    return send(url, data, otherOptions, "delete");
  }
  getNormal(data: any, otherOptions: any) {
    let url = `${this.url}`;
    url = formatUrl(url, data);
    return send(url, data, otherOptions);
  }

  static get(url: any, data: any, otherOptions: any) {
    url = formatUrl(url, data);
    return send(url, data, otherOptions);
  }
  static post(url: any, data: any, otherOptions: any) {
    url = formatUrl(url, data);
    return send(url, data, otherOptions, "post");
  }
  static put(url: any, data: any, otherOptions: any) {
    url = formatUrl(url, data);
    return send(url, data, otherOptions, "put");
  }
  static delete(url: any, data: any, otherOptions: any) {
    url = formatUrl(url, data);
    return send(url, data, otherOptions, "delete");
  }
}
function send<T>(
  url: string,
  data: Record<string, any>,
  otherOptions: Record<string, any>,
  method = "get"
): Promise<BaseResponse<T>> {
  return new Promise((resolve, reject) => {
    let config = {};
    if (method == "get") {
      config = Object.assign(
        {},
        { url: url, method: method, params: data },
        otherOptions
      );
    } else {
      config = Object.assign(
        {},
        { url: url, method: method, data: data },
        otherOptions
      );
    }
    axios
      .request(config)
      .then((res) => {
        var data = res.data;
        if (data.size) {
          data = Object.assign({}, res.data, res);
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function isFormatUrl(url: string | string[]) {
  return url.indexOf("{") !== -1 && url.indexOf("}") !== -1;
}

function formatUrl(url: string, dataModel: { [x: string]: any; }, options = {}) {
  if (!options.hasOwnProperty("removeFormatModelProp")) {
    // 默认移除datamodel中的已经在url中使用的format属性
    //@ts-ignore
    options.removeFormatModelProp = true;
  }
  if (isFormatUrl(url)) {
    if (dataModel) {
      Object.keys(dataModel).forEach(function (key) {
        var varName = "{" + key + "}";
        if (url.indexOf(varName) !== -1) {
          url = url.replace(new RegExp(varName, "gm"), dataModel[key]);
          // 格式化url后是否将datamodel中的对应属性移除
          //@ts-ignore
          if (options.removeFormatModelProp) {
            delete dataModel[key];
          }
        }
      });
    } else {
      url.split("{").forEach(function (item: string | string[]) {
        if (item.indexOf("}") === item.length - 1) {
          url = url.replace("{" + item, "");
        }
      });
    }
    return url;
  } else {
    return url;
  }
}
